if (!customElements.get('product-faq')) {
  class ProductFaq extends HTMLElement {
    connectedCallback() {
      this._onClick = (event) => this._handleClick(event);
      this._onKeyDown = (event) => this._handleKeyDown(event);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeyDown);

      this.querySelectorAll('.product-faq-item > .title').forEach((title) => {
        if (!(title instanceof HTMLElement)) return;

        title.setAttribute('role', 'button');
        title.setAttribute('tabindex', '0');

        const isOpen = title.classList.contains('open');
        title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        this._syncAnswer(title, isOpen);
      });

      this._openFirstByDefault();
    }

    _openFirstByDefault() {
      const titles = this.querySelectorAll('.product-faq-item > .title');
      const hasOpen = Array.from(titles).some(
        (title) => title instanceof HTMLElement && title.classList.contains('open')
      );
      if (hasOpen) return;

      const first = titles[0];
      if (!(first instanceof HTMLElement)) return;

      first.classList.add('open');
      first.setAttribute('aria-expanded', 'true');
      this._syncAnswer(first, true);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeyDown);
      this._onClick = null;
      this._onKeyDown = null;
    }

    /**
     * @param {HTMLElement} title
     * @returns {HTMLElement | null}
     */
    _getAnswer(title) {
      const item = title.closest('.product-faq-item');
      const text = item instanceof HTMLElement ? item.querySelector(':scope > .text') : null;
      return text instanceof HTMLElement ? text : null;
    }

    /**
     * @param {HTMLElement} title
     * @param {boolean} isOpen
     */
    _syncAnswer(title, isOpen) {
      const text = this._getAnswer(title);
      if (!text) return;

      if (isOpen) {
        text.removeAttribute('hidden');
        text.style.display = 'block';
        return;
      }

      text.style.display = 'none';
      text.setAttribute('hidden', '');
    }

    /**
     * @param {HTMLElement} title
     */
    _toggle(title) {
      const isOpen = title.classList.contains('open');
      title.classList.toggle('open', !isOpen);
      title.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      this._syncAnswer(title, !isOpen);
    }

    /**
     * @param {Event} event
     * @returns {HTMLElement | null}
     */
    _titleFromEvent(event) {
      const target = event.target;
      if (!(target instanceof Element)) return null;

      const title = target.closest('.product-faq-item > .title');
      if (!(title instanceof HTMLElement) || !this.contains(title)) return null;
      return title;
    }

    /**
     * @param {MouseEvent} event
     */
    _handleClick(event) {
      const title = this._titleFromEvent(event);
      if (!title) return;
      this._toggle(title);
    }

    /**
     * @param {KeyboardEvent} event
     */
    _handleKeyDown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      const title = this._titleFromEvent(event);
      if (!title) return;

      event.preventDefault();
      this._toggle(title);
    }
  }

  customElements.define('product-faq', ProductFaq);
}
